<template>
  <div class="new-container">
    <!-- 顶部导航栏 -->
    <div id="home" :class="{ 'scrolled': isNavScrolled }" class="nav">
      <div class="nav-main">
        <div class="nav-logo">
          <img alt="" src="@/assets/image/logo.png"/>
          <img alt="" src="@/assets/image/logo-text.png"/>
        </div>
        <div class="nav-info">
          <div :class="{ active: activeNav === 'home' }" class="nav-item">
            <a href="#home" @click.prevent="scrollToSection('home')">{{ t('top.首页') }}</a>
          </div>
          <div :class="{ active: activeNav === 'team' }" class="nav-item">
            <a href="#team" @click.prevent="scrollToSection('team')">{{ t('top.公司团队') }}</a>
          </div>
          <div :class="{ active: activeNav === 'product' }" class="nav-item">
            <a href="#product" @click.prevent="scrollToSection('product')">{{ t('top.公司产品') }}</a>
          </div>
          <div :class="{ active: activeNav === 'partner' }" class="nav-item Partners">
            <a href="#partner" @click.prevent="scrollToSection('partner')">{{ t('top.全球合作伙伴') }}</a>
            <div class="learn-more" @click="checkPartner(1)">
              <span>{{ t('top.了解更多') }}</span>
            </div>
          </div>
          <div :class="{ active: activeNav === 'contact' }" class="nav-item">
            <a href="#contact" @click.prevent="scrollToSection('contact')">{{ t('top.联系我们') }}</a>
          </div>
        </div>
        <div v-if="isEnglish" class="nav-login" @click="changeLocal">
          <span>Switch to Chinese</span>
        </div>
        <div v-else class="nav-login" @click="changeLocal">
          <span>切换英文</span>
        </div>
        <div v-if="false" class="nav-btn">
          <span>Become a member</span>
          <span>→</span>
        </div>
      </div>
    </div>
    <!-- 第一部分 -->
    <div class="top">
      <div class="top-title">
        <div class="title">{{ t('top.热爱&专业&坚持') }}</div>
        <div class="info">{{ t('top.南京禄高运动器材有限公司') }}</div>
        <div class="top-btn">
          <span><a href="#team">{{ t('top.快速开始') }}</a></span>
          <span><a href="#contact">{{ t('top.了解更多') }}</a></span>
        </div>
      </div>
      <div class="features">
        <div class="feature">
          <div class="feature-icon"></div>
          <h2>{{ t('introduce.强大的工厂依托') }}</h2>
          <p class="feature-description">
            {{
              t('introduce.旗下工厂拥有先进的生产设施与专业的技术团队。工厂内配备一系列自动化生产设备，从原材料进厂到成品的组装，每一个生产环节都实现了高效、精准的运作，确保产品的稳定供应。同时，工厂高度重视产品质量，建立了严格的质量管理体系，每一件产品都经过层层筛选，以卓越的品质符合甚至超越国际质量标准，为贸易业务提供了坚实可靠的产品保障。')
            }}
          </p>
        </div>
        <div class="feature">
          <div class="feature-icon"></div>
          <h2>{{ t('introduce.卓越的研发能力') }}</h2>
          <p class="feature-description">{{
              t('introduce.依托工厂的专业研发团队，公司在球类产品的创新上表现卓越。研发人员凭借深厚的行业经验与对市场趋势的敏锐洞察，持续探索新材料、新工艺，不断推陈出新。目前已成功研发出多款具备独特性能与外观设计的球类产品，部分创新成果获得国家专利，使公司在激烈的市场竞争中脱颖而出，能够为客户提供更具竞争力、更符合市场需求的产品选择。')
            }}</p>
        </div>
        <div class="feature">
          <div class="feature-icon"></div>
          <h2>{{ t('introduce.丰富的合作经验') }}</h2>
          <p class="feature-description">
            {{
              t('introduce.凭借出色的产品质量与服务能力，公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系。在代工过程中，严格遵循品牌方的各项要求，从产品设计理念的贯彻到生产工艺的精准执行，都力求完美，确保每一款代工产品都能充分展现品牌方的特色与品质标准。丰富的代工经验使公司能够灵活应对各种复杂的订单需求，无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。')
            }}
          </p>
        </div>
      </div>
      <!-- 背景图 -->
      <img alt="" class="bg" src="@/assets/image/background.webp">
    </div>
    <!-- 公司团队 -->
    <div id="team" class="team">
      <div class="team-title">
        <p v-if="isEnglish" class="title">Team <i class="title-en">公司团队</i></p>
        <p v-else class="title">公司团队 <i class="title-en">Team</i></p>
        <span>{{
            t('team.公司拥有一支专业且经验丰富的外贸团队，熟悉国际贸易流程与规则，具备成熟完善的进出口能力。')
          }}</span>
      </div>
      <div class="team-main" @click="checkTeam">
        <div class="team-item">
          <!--<video autoplay loop="loop" muted="muted" src="@/assets/video/factory.mp4"></video>-->
          <img v-if="imgOptions && imgOptions[0].picture" :src="imgOptions[0].picture" alt="" class="team-img">
          <div class="team-info">
            <span :style="{ lineHeight: isEnglish ? 1.5 : 2 }">
              {{
                t('team.团队能够高效处理各类进出口业务，从合同签订、报关报检、物流运输到售后服务，为客户提供全方位、一站式的贸易服务。公司与全球多个国家和地区的客户建立了良好的贸易往来，产品畅销海外市场，深受国际客户的认可与好评。同时，积极引进国外先进的生产技术与管理经验，不断优化自身业务流程，提升综合实力，以更好地适应全球市场的变化与需求。')
              }}
            </span>
          </div>
        </div>
        <div class="team-item">
          <div class="team-info">
            <span :style="{ lineHeight: isEnglish ? 1.5 : 2 }">
              {{
                t('team.工厂汇聚行业内资深的专业人才，拥有经验丰富的研发设计团队、熟练精湛的生产技术骨干，以及严谨细致的质检人员。研发团队持续探索新型材料与工艺，已获得多项国家专利；生产技术人员凭借精湛技艺，保障产品高效稳定产出；质检团队严格把控每一道工序，确保产品零缺陷出厂。凭借严格的品控体系，从原料采购到成品出厂，每道工序均设置严格质检节点，确保零缺陷品控。')
              }}
            </span>
          </div>
          <img v-if="imgOptions && imgOptions[1].picture" :src="imgOptions[1].picture" alt="" class="team-img">
          <!--<video autoplay loop="loop" muted="muted" src="@/assets/video/factory.mp4"></video>-->
        </div>
      </div>
    </div>
    <!-- 公司产品 -->
    <div id="product" class="product">
      <div class="product-title">
        <p v-if="isEnglish" class="title">Product <i class="title-en">公司产品</i></p>
        <p v-else class="title">公司产品 <i class="title-en">Product</i></p>
        <span class="product-info">{{ t('product.info') }}</span>
      </div>
      <div class="product-main">
        <div v-for="(i,index) in goodsInfo"
             :key="i.id" class="card"
             @click="checkProduce(index)"
             @mouseenter="setCardBackground($event, i.picture2)"
             @mouseleave="removeCardBackground($event)"
        >
          <div class="first-content">
            <img :src="i.picture1" alt="">
            <span>{{ i.name }}</span>
            <span>{{ i.nameEn }}</span>
          </div>
          <!--TODO: 文案描述暂时隐藏-->
          <div class="second-content">
            <span v-if="false">{{ i.description }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div id="partner" class="partner">
      <div class="partner-title">
        <p v-if="isEnglish" class="title">Partner <i class="title-en">合作伙伴</i></p>
        <p v-else class="title">合作伙伴 <i class="title-en">Partner</i></p>
        <span class="partner-info">
          {{
            t('friend.公司通过旗下工厂与多个知名品牌建立了长期稳定的 OEM 代工合作关系，无论是产品的定制化设计，还是大规模的批量生产，都能为客户提供专业、高效、个性化的服务。')
          }}
        </span>
      </div>
      <div class="app-container">
        <div class="logo-wall">
          <div class="scroll-container top-track">
            <div v-for="(group, index) in groupedImages1" :key="index" class="logo-group">
              <div v-for="(image, i) in group" :key="i" class="logo-item" @click="checkPartner(image.id)">
                <img :alt="`合作伙伴${index * group.length + i + 1}`" :src="image.url"/>
              </div>
            </div>
          </div>

          <div class="scroll-container bottom-track">
            <div v-for="(group, index) in groupedImages2" :key="index" class="logo-group">
              <div v-for="(image, i) in group" :key="i" class="logo-item" @click="checkPartner(image.id)">
                <img
                    :alt="`合作伙伴${groupedImages1.length * groupedImages1[0].length + index * group.length + i + 1}`"
                    :src="image.url"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div id="contact" class="contact">
      <div class="contact-main">
        <div class="contact-title">
          <p v-if="isEnglish" class="title">Contact <i class="title-en">联系我们</i></p>
          <p v-else class="title">联系我们 <i class="title-en">Contact</i></p>
          <span>{{ t('connect.合作咨询、咨询留言。填写以下信息，我们的团队将尽快与您联系。感谢您的信任！') }}</span>
        </div>
        <!--<img alt="" src="@/assets/image/world.png">-->
      </div>
      <div class="contact-container">
        <div class="contact-form">
          <h2>{{ t('connect.预约') }}</h2>
          <form @submit.prevent="bookAppointment">
            <el-form :model="formData" label-width="auto">
              <el-form-item>
                <div class="form-group">
                  <label for="name">{{ t('connect.公司/品牌名称*') }}</label>
                  <input id="name" v-model="formData.name" class="input" placeholder="Full Name *" required
                         type="text">
                </div>
              </el-form-item>
              <el-form-item>
                <div class="form-group">
                  <label for="email">{{ t('connect.邮箱*') }}</label>
                  <input id="email" v-model="formData.email" class="input" placeholder="example@gmail.com" required
                         type="email">
                </div>
              </el-form-item>
              <el-form-item>
                <div class="form-group">
                  <label for="phone" style="font-weight: bold">{{ t('connect.联系电话*') }}</label>
                  <input id="phone" v-model="formData.phone" class="input" placeholder="Contact Number*"
                         required>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="form-group">
                  <label for="time" style="font-weight: bold">{{ t('connect.需求建议*') }}</label>
                  <input id="time" v-model="formData.suggest" class="input" placeholder="Requirements/Suggestions*"
                         required>
                </div>
              </el-form-item>
            </el-form>
            <button class="button-style" type="submit">
              {{ t('connect.提交信息') }}
            </button>
          </form>
        </div>
        <!-- 地图数据 -->
        <div id="world" class="world">
          <World :displayChinese="!isEnglish"></World>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <div class="footer">
      <!-- 目前不需要展示这么多内容 -->
      <div v-if="false" class="footer-main">
        <div class="footer-item">
          <p>Company Info</p>
          <span>About Us</span>
          <span>Carrier</span>
          <span>We are hiring</span>
          <span>Blog</span>
        </div>
        <div class="footer-item">
          <p>Legal</p>
          <span>About Us</span>
          <span>Carrier</span>
          <span>We are hiring</span>
          <span>Blog</span>
        </div>
        <div class="footer-item">
          <p>Features</p>
          <span>Business Marketing</span>
          <span>User Analytic</span>
          <span>Live Chat</span>
          <span>Unlimited Support</span>
        </div>
        <div class="footer-item">
          <p>Resources</p>
          <span>IOS & Android</span>
          <span>Watch a Demo</span>
          <span>Customers</span>
          <span>API</span>
        </div>
        <div class="footer-item last-item">
          <p>Get In Touch</p>
          <div class="footer-contact">
            <img alt="" src="@/assets/image/icon-4.png">
            <span>(86-025-56213098</span>
          </div>
          <div class="footer-contact">
            <img alt="" src="@/assets/image/icon-5.png">
            <span>江苏省南京市溧⽔区永阳街道涌泉路89号天安</span>
          </div>
          <div class="footer-contact">
            <img alt="" src="@/assets/image/icon-6.png">
            <span>brook@lg-sport.com</span>
          </div>
        </div>
      </div>
      <div class="footer-contact-main">
        <div class="footer-contact">
          <img alt="" src="@/assets/image/icon-4.png">
          <span>86-025-56213098</span>
        </div>
        <div class="footer-contact">
          <img alt="" src="@/assets/image/icon-5.png">
          <span>{{ t('footer.江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室') }}</span>
        </div>
        <div class="footer-contact">
          <img alt="" src="@/assets/image/icon-6.png">
          <div style="text-align: left">
            <p>brook@lg-sport.com</p>
            <p>kay@lg-sport.com</p>
            <p>sales01@lg-sport.com</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 版权 -->
    <div class="copyright">
      <div class="copyright-main">
        <div class="copyright-text">
          <span>© 2025 LG-sports. All rights reserved</span>
          <p>备案号: <a href="https://beian.miit.gov.cn/">苏ICP备2023012397号-2</a></p>
        </div>
        <div class="platform">
          <el-popover>
            <template #reference>
              <img alt="" src="@/assets/image/icon-9.png">
            </template>
            <template #default>
              <div v-if="imgOptions && imgOptions[2].picture" class="platform-list">
                <img v-for="(item,index) in imgOptions[2].picture.split(',')" :key="index" :src="item" alt=""
                     style="width: 100%;object-fit: cover">
              </div>
            </template>
          </el-popover>
          <el-popover>
            <template #reference>
              <img alt="" src="@/assets/image/icon-9.png">
            </template>
            <template #default>
              <div v-if="imgOptions && imgOptions[3].picture" class="platform-list">
                <img v-for="(item,index) in imgOptions[3].picture.split(',')" :key="index" :src="item" alt=""
                     style="width: 100%;object-fit: cover">
              </div>
            </template>
          </el-popover>
          <el-popover>
            <template #reference>
              <img alt="" src="@/assets/image/icon-9.png">
            </template>
            <template #default>
              <div v-if="imgOptions && imgOptions[4].picture" class="platform-list">
                <img v-for="(item,index) in imgOptions[4].picture.split(',')" :key="index" :src="item" alt=""
                     style="width: 100%;object-fit: cover">
              </div>
            </template>
          </el-popover>
        </div>
      </div>
    </div>
    <!-- 回到顶部 -->
    <el-backtop :bottom="100" :right="100" :visibility-height="500"/>
  </div>
</template>


<script setup>
import {computed, defineAsyncComponent, nextTick, onActivated, onBeforeUnmount, onMounted, ref} from "vue"
import i18n from "@/locale"
import {useI18n} from 'vue-i18n'
import {setToken} from "@/utils/auth"
import {useRouter} from "vue-router"
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import {ElMessage} from "element-plus"
import {partnerImagesGroup1, partnerImagesGroup2} from "@/data/partners"
import {addContact, getImgOptions, getType} from "@/api/index"

const World = defineAsyncComponent(() => import('@/components/WorldMap.vue'))

const router = useRouter()
const {t} = useI18n()

const swiperRef = ref(null)
const isNavScrolled = ref(false)
const ticking = ref(false)
const formData = ref({
  name: '',
  email: '',
  phone: '',
  suggest: ''
})
const isEnglish = computed(() => i18n.global.locale.value === "en")
const activeNav = ref('home')
const imgArr1 = partnerImagesGroup1
const imgArr2 = partnerImagesGroup2
const goodsInfo = ref([])
const imgOptions = ref(null)
const mobileMenuOpen = ref(false)
const isMobile = ref(false)

const groupedImages1 = computed(() => [imgArr1, imgArr1])
const groupedImages2 = computed(() => [imgArr2, imgArr2])

const bookAppointment = () => {
  if (!validateForm()) return
  const data = {
    name: formData.value.name,
    email: formData.value.email,
    phone: formData.value.phone,
    text: formData.value.suggest
  }
  addContact(data).then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t('message.数据获取失败'))
    ElMessage.success(i18n.global.t('message.操作成功'))
    formData.value = {
      name: '',
      email: '',
      phone: '',
      suggest: ''
    }
  })
}
const checkPartner = (id) => {
  router.push('/brand/' + id)
}
const handleScroll = () => {
  if (!ticking.value) {
    requestAnimationFrame(() => {
      isNavScrolled.value = window.scrollY > 100
      ticking.value = false

      const sections = ['home', 'team', 'product', 'partner', 'contact']
      const currentSection = sections.findLast(section => {
        const element = document.getElementById(section)
        if (element) {
          const rect = element.getBoundingClientRect()
          // 对于首页(home)做特殊处理，当滚动位置在页面顶部附近时激活
          if (section === 'home') {
            return rect.top <= 100 && (rect.bottom >= 100 || window.scrollY < 100)
          }
          return rect.top <= 100 && rect.bottom >= 100
        }
        return false
      })

      if (currentSection) {
        activeNav.value = currentSection
      }
    })
    ticking.value = true
  }
}
const setCardBackground = (event, imgUrl) => {
  const secondContent = event.currentTarget.querySelector('.second-content')
  if (secondContent) {
    secondContent.style.backgroundImage = `url(${imgUrl})`
  }
}
const removeCardBackground = (event) => {
  const secondContent = event.currentTarget.querySelector('.second-content')
  if (secondContent) {
    secondContent.style.backgroundImage = 'none'
  }
}
const changeLocal = () => {
  i18n.global.locale.value = i18n.global.locale.value === 'zh-Hans' ? 'en' : 'zh-Hans'
  setToken('language', i18n.global.locale.value)
}
const scrollToSection = (sectionId) => {
  // 小屏幕下先关闭下拉菜单
  if (mobileMenuOpen.value) {
    mobileMenuOpen.value = false
    const navInfo = document.querySelector('.nav-info')
    if (navInfo) navInfo.classList.remove('mobile-open')
  }
  const element = document.getElementById(sectionId)
  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth'
    })
    activeNav.value = sectionId
  }
}
const checkProduce = (index) => {
  router.push('/goods?index=' + index)
}
const validateForm = () => {
  if (formData.value.name.trim() === '') {
    ElMessage.error(t('message.请输入公司姓名'))
    return false
  }
  if (formData.value.suggest.trim() === '') {
    ElMessage.error(t('message.请输入您的建议'))
    return false
  }
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (!emailRegex.test(formData.value.email)) {
    ElMessage.error(t('message.请输入正确的邮箱格式'))
    return false
  }
  const phoneRegex = /^(\+?\d{1,3}[-.\s]?)?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/
  if (!phoneRegex.test(formData.value.phone)) {
    ElMessage.error(t('message.请输入正确的联系电话'))
    return false
  }
  return true
}
const getTypeList = () => {
  getType().then(res => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t('message.数据获取失败'))
    goodsInfo.value = res.typeInfoList
  })
}
const checkTeam = () => {
  router.push('/team')
}
const getOptions = () => {
  getImgOptions().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t('message.数据获取失败'))
    imgOptions.value = res.footPictureInfoList
  })
}
const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
  const navInfo = document.querySelector('.nav-info')
  if (mobileMenuOpen.value) {
    navInfo.classList.add('mobile-open')
  } else {
    navInfo.classList.remove('mobile-open')
  }
}
const addBtn = () => {
  if (!isMobile.value) return
  if (document.querySelector('.hamburger-menu')) return
  const hamburgerBtn = document.querySelector('.nav-main')
  if (hamburgerBtn) {
    const hamburger = document.createElement('div')
    hamburger.className = 'hamburger-menu'
    hamburger.innerHTML = '☰'
    hamburger.style.cssText = `      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      cursor: pointer;
      color: #fff;
      z-index: 31;
    `
    const updateHamburgerColor = () => {
      if (isNavScrolled.value) {
        hamburger.style.color = '#000'
      } else {
        hamburger.style.color = '#fff'
      }
    }
    updateHamburgerColor()
    hamburger.addEventListener('click', toggleMobileMenu)
    hamburgerBtn.appendChild(hamburger)
  }
}
const checkScreenSize = () => {
  isMobile.value = window.innerWidth <= 768
}
const removeBtn = () => {
  const existingBtn = document.querySelector('.hamburger-menu')
  if (existingBtn) {
    existingBtn.remove()
  }
}
const handleResize = () => {
  checkScreenSize()
  if (isMobile.value) {
    nextTick(() => {
      addBtn()
    })
  } else {
    removeBtn()
  }
}

onMounted(() => {
  checkScreenSize()
  isNavScrolled.value = window.scrollY > 100
  getTypeList()
  getOptions()
  window.addEventListener('scroll', handleScroll)

  const sections = ['home', 'team', 'product', 'partner', 'contact']
  const currentSection = sections.findLast(section => {
    const element = document.getElementById(section)
    if (element) {
      const rect = element.getBoundingClientRect()
      // 对于首页做特殊处理
      if (section === 'home') {
        return rect.top <= 100 && (rect.bottom >= 100 || window.scrollY < 100)
      }
      return rect.top <= 100 && rect.bottom >= 100
    }
    return false
  })

  if (currentSection) {
    activeNav.value = currentSection
  } else {
    activeNav.value = 'home'
  }
  if (isMobile.value) {
    addBtn()
  }
  window.addEventListener('resize', handleResize)

  // 处理 URL hash 初始滚动（如 /#partner）
  if (window.location.hash) {
    const sectionId = window.location.hash.substring(1)
    nextTick(() => {
      setTimeout(() => {
        const el = document.getElementById(sectionId)
        if (el) {
          window.scrollTo({ top: el.offsetTop, behavior: 'smooth' })
          activeNav.value = sectionId
        }
      }, 400)
    })
  }
})
// keep-alive 缓存后重新激活时处理 hash 滚动
onActivated(() => {
  // 缓存恢复时关闭可能处于展开状态的移动端菜单
  if (mobileMenuOpen.value) {
    mobileMenuOpen.value = false
    const navInfo = document.querySelector('.nav-info')
    if (navInfo) navInfo.classList.remove('mobile-open')
  }
  if (window.location.hash) {
    const sectionId = window.location.hash.substring(1)
    nextTick(() => {
      setTimeout(() => {
        const el = document.getElementById(sectionId)
        if (el) {
          window.scrollTo({ top: el.offsetTop, behavior: 'smooth' })
          activeNav.value = sectionId
        }
      }, 400)
    })
  }
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('scroll', handleScroll)
  if (swiperRef.value) {
    swiperRef.value.destroy()
  }
})
</script>

<style lang="scss" scoped>
.new-container {
  //  顶部导航栏
  .nav {
    width: 100%;
    height: 80px;
    //background: var(--new-bgColor1);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 30;
    transition: all 0.5s;

    .nav-main {
      width: 60%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;

      .nav-logo {
        width: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 100%;
        }
      }

      .nav-info {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;

        .nav-item {
          width: 100px;
          text-align: center;
          position: relative;
          height: 100%;

          a {
            display: block;
            font-weight: bold;
            font-style: italic;
            transition: all 0.5s;
            cursor: pointer;
            color: #fff;
            line-height: 1.4;
            height: 100%;

            &:hover {
              color: var(--new-btnColor);
              transform: scale(1.2);
            }
          }

          .learn-more {
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            background: var(--new-btnColor);
            border-radius: 0 0 6px 6px;
            height: 0;
            line-height: 0;
            text-align: center;
            transition: all 0.5s;
            opacity: 0;
            z-index: 10;

            span {
              display: none;
              font-weight: bold;
              font-style: italic;
              transition: all 0.5s;
              cursor: pointer;
              color: #fff;
              text-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

              &:hover {
                transform: scale(1.1);
              }
            }
          }
        }


        .active {
          a {
            color: var(--new-btnColor);
            transform: scale(1.2);
          }
        }

        // 合作伙伴
        .Partners:hover {
          .learn-more {
            height: 40px;
            line-height: 40px;
            opacity: 1;

            span {
              display: block;
            }
          }
        }

      }

      .nav-login {
        width: 160px;
        text-align: center;

        &:hover {
          cursor: pointer;
        }

        span {
          font-weight: bold;
          color: #fff;
          transition: all 0.5s;
          line-height: 1.4;
        }
      }

      .nav-btn {
        padding: 15px 10px;
        background: var(--new-btnColor);
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        span {
          color: #fff;
          display: block;
          font-weight: bold;
          transition: all 0.5s;
        }
      }
    }
  }

  // 顶部导航栏滑动后的样式
  .scrolled {
    background: var(--new-bgColor1);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

    .nav-main {
      .nav-info {
        .nav-item {
          &.active {
            a {
              color: var(--new-btnColor);
              transform: scale(1.2);
            }
          }

          a {
            color: #000;
          }
        }
      }

      .nav-login {
        span {
          color: #000;
        }
      }

      .nav-btn {
        span {
          color: #000;
        }
      }
    }
  }

  // 第一部分
  .top {
    width: 100%;
    //background: var(--new-bgColor1);
    height: 100vh;
    padding-top: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    position: relative;
    z-index: 1;
    overflow: hidden;

    .top-title {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      margin: 40px 0;

      .title {
        font-size: 80px;
        font-weight: bold;
        font-style: italic;
        color: #fff;
      }

      .info {
        font-size: 18px;
        font-style: italic;
        margin: 40px 0;
        color: #fff;
      }

      .top-btn {
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          width: 180px;
          padding: 15px 0;
          border-radius: 36px;
          text-align: center;
          border: 1px solid #fff;
          margin: 0 20px;
          transition: all 0.5s;
          cursor: pointer;

          a {
            color: #fff;
          }

          &:hover {
            border: 1px solid var(--new-btnColor);
            background: var(--new-btnColor);
            transform: scale(1.1);
          }
        }

        .active {
          border: 1px solid var(--new-btnColor);
          background: var(--new-btnColor);
          transform: scale(1.1);
        }
      }
    }

    .features {
      margin: 0 auto;
      width: 90%;
      display: flex;
      justify-content: space-around;
      padding: 20px 0;

      .feature {
        text-align: center;
        padding: 30px;
        border-radius: 10px;
        width: 30%;
        margin: 0 10px 20px;
        background-color: #fff;
        transition: all 0.5s;
        overflow: hidden;
        position: relative;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

        &::before {
          content: "";
          height: 100px;
          width: 100px;
          position: absolute;
          top: -60%;
          left: -20%;
          border-radius: 50%;
          border: 35px solid transparent;
          transition: all .8s ease;
          filter: blur(.5rem);
        }


        h2 {
          font-size: 24px;
          margin: 20px 0;
        }

        .feature-description {
          font-size: 16px;
          color: #666;
          text-indent: 2em;
        }

        &:hover {
          background-color: var(--new-btnColor);
          color: #fff;
          transform: translateY(-10px);
          box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.2);

          &::before {
            width: 140px;
            height: 140px;
            top: -45%;
            left: 70%;
            filter: blur(0rem);
            border-color: rgb(247, 234, 234);
          }

          .feature-description {
            color: #fff;
            cursor: default;
          }
        }
      }
    }

    .bg {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100vh;
      z-index: -2;
      object-fit: cover;
      transform: scale(1);
      transform-origin: center center;
      animation: bgZoom 20s linear infinite;
    }

    @keyframes bgZoom {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }
  }

  // 第二部分
  .team {
    width: 100%;
    height: 100vh;
    background: var(--new-bgColor2);
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;

    .team-title {
      width: 30%;

      .title {
        color: #fff;
        margin: 40px 0;
        font-size: 40px;
        font-weight: bold;

        .title-en {
          font-weight: 800;
          color: var(--new-btnColor);
        }
      }

      span {
        width: 80%;
        color: #fff;
        font-size: 14px;
        display: block;
        margin: 10px auto;
        line-height: 2;
      }
    }

    .team-main {
      flex: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      gap: 40px;

      .team-item {
        display: flex;
        align-items: stretch;
        justify-content: space-around;
        gap: 40px;
        height: auto;

        video, .team-img {
          width: 40% !important;
          border-radius: 12px;
          object-fit: cover;
          min-width: 0;
        }

        .team-info {
          width: 50%;
          background: #fff;
          border-radius: 12px;
          padding: 30px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          gap: 10px;
          min-height: 200px;
          min-width: 0;

          p {
            font-size: 20px;
            text-align: left;
            font-weight: bold;
          }

          span {
            font-size: 16px;
            text-align: left;
            line-height: 2;
            text-indent: 2em;
            flex-grow: 1;
            display: flex;
            align-items: center;
          }
        }
      }
    }

  }

  // 第三部分
  .product {
    width: 100%;
    height: 100vh;
    background: var(--new-bgColor1);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;

    .product-title {
      width: 100%;

      .title {
        color: #000;
        margin: 40px 0;
        font-size: 40px;
        font-weight: bold;

        .title-en {
          font-weight: 800;
          color: red;
        }
      }

      .product-info {
        color: #000;
        font-size: 14px;
        display: block;
        margin: 10px auto;
        line-height: 2;
        width: 60%;
      }
    }

    .product-main {
      width: 90%;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 40px;

      .card {
        transition: all 0.4s;
        aspect-ratio: 1;
        width: 70%;
        margin: 0 auto;

        &:hover {
          border-radius: 15px;
          cursor: pointer;
          transform: scale(1.1);
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
          z-index: 2;

          .first-content {
            height: 0;
            opacity: 0;
            padding: 0;
          }

          .second-content {
            opacity: 1;
            height: 100%;
            font-size: 1.8rem;
            transform: rotate(0deg);
            padding: 20px;
          }
        }

        .first-content {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: all 0.4s;
          gap: 10px;

          img {
            width: 60%;
          }

          span {
            font-size: 25px;
            font-weight: bold;
          }
        }

        .second-content {
          height: 0;
          width: 100%;
          opacity: 0;
          display: flex;
          margin: 0 auto;
          justify-content: center;
          align-items: center;
          border-radius: 15px;
          transition: all 0.4s;
          font-size: 0;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          transform: rotate(90deg) scale(-1);

          span {
            color: #fff;
            text-align: center;
            font-size: 14px;
            width: 100%;
            display: block;
          }
        }
      }

      @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 480px) {
        grid-template-columns: 1fr;
      }
    }
  }

  // 第四部分
  .partner {
    width: 100%;
    height: 100vh;
    background: var(--new-bgColor2);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;

    .partner-title {
      width: 100%;
      margin: 60px 0;

      .title {
        color: #fff;
        margin: 40px 0;
        font-size: 40px;
        font-weight: bold;
      }

      .partner-info {
        color: #fff;
        font-size: 14px;
        display: block;
        margin: 10px auto;
        line-height: 2;
        width: 60%;
      }
    }

    .app-container {
      width: 60%;
      max-width: 100vw;
      margin: 0 auto;
      overflow-x: hidden;
    }

    .logo-wall {
      width: 100%;
      overflow: hidden;
      position: relative;
      padding: 20px 0;

      &::before,
      &::after {
        content: '';
        position: absolute;
        top: 0;
        height: 100%;
        width: 100px;
        z-index: 10;
        pointer-events: none;
      }

      &::before {
        left: 0;
        background: linear-gradient(to right, var(--new-bgColor2) 70%, transparent 100%);
      }

      &::after {
        right: 0;
        background: linear-gradient(to left, var(--new-bgColor2) 70%, transparent 100%);
      }

      .scroll-container {
        display: flex;
        align-items: center;
        width: 200%;

        &.top-track {
          animation: scroll-right 20s linear infinite;
        }

        &.bottom-track {
          animation: scroll-left 20s linear infinite;
          margin-top: 20px;
        }

        &:hover {
          animation-play-state: paused;
          cursor: pointer;
        }

        .logo-group {
          display: flex;
          justify-content: space-around;
          width: 100%;
          gap: 20px;
          margin-right: 20px;

          .logo-item {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 80px;
            width: 160px;
            padding: 10px;
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            flex-shrink: 0;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
            }

            img {
              max-height: 100%;
              max-width: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }

    @keyframes scroll-right {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }

    @keyframes scroll-left {
      from {
        transform: translateX(-50%);
      }
      to {
        transform: translateX(0);
      }
    }
  }

  // 第五部分
  .contact {
    width: 100%;
    height: 100vh;
    background: var(--new-bgColor1);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;

    .contact-main {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .contact-title {
        width: 40%;

        .title {
          color: #000;
          margin: 40px 0;
          font-size: 40px;
          font-weight: bold;
          text-align: center;
        }

        span {
          color: #000;
          font-size: 14px;
          display: block;
          margin: 10px 0;
          text-align: center;
        }
      }

      img {
        width: 20%;
        object-fit: cover;
      }
    }

    .contact-container {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .contact-form {
        width: 30%;
        height: 600px;
        padding: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: #fff;
        border-radius: 12px;

        h2 {
          text-align: center;
          margin-bottom: 20px;
          font-size: 24px;
        }

        form {
          display: flex;
          flex-direction: column;

          .form-group {
            width: 100%;

            label {
              display: block;
              font-weight: bold;
              font-size: 15px;
              text-align: left;
            }

            input, select {
              width: 100%;
              padding: 10px;
              border: 1px solid #ccc;
              border-radius: 4px;
            }
          }

          button {
            width: 100%;
            padding: 15px 0;
            border-radius: 36px;
            text-align: center;
            border: 1px solid #ccc;
            transition: all 0.5s;
            cursor: pointer;
            background: transparent;
            margin-top: 10px;

            &:hover {
              border: 1px solid var(--new-btnColor);
              background: var(--new-btnColor);
              transform: scale(1.1);
              color: #fff;
            }
          }
        }

        .input {
          background-color: #f8f8f8;
          border: 2px solid transparent;
          width: 100%;
          padding-left: 0.8em;
          outline: none;
          overflow: hidden;
          border-radius: 10px;
          transition: all 0.5s;
        }

        .input:hover,
        .input:focus {
          border: 1px solid #fff;
          box-shadow: 0 0 0 7px rgb(74, 157, 236, 20%);
          background-color: white;
        }

        :deep(.el-select) {
          width: 100%;

          .el-select__wrapper {
            background-color: white;
          }

          &.is-focus .el-select__wrapper,
          &:not(.is-empty) .el-select__wrapper {
            background-color: #f8f8f8;
          }
        }
      }

      .world {
        width: 55%;
      }
    }
  }

  // 第六部分
  .footer {
    width: 100%;
    background: var(--new-bgColor2);
    //padding: 40px 0; 内容展示没有那么多，就不要留空了
    padding: 10px 0;
    font-weight: lighter;
    font-size: 14px;

    .footer-main {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      .footer-item {
        width: 15%;
        color: #fff;
        font-weight: bold;

        p {
          font-size: 20px;
        }

        span {
          display: block;
          margin: 20px 0;
          font-size: 14px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .last-item {
        width: 25%;

        p {
          margin-bottom: 20px;
        }

        .footer-contact {
          width: 100%;
          display: flex;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            display: block;
            margin-right: 20px;
          }

          span {
            margin: 10px 0;
          }
        }
      }
    }

    .footer-contact-main {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      .footer-contact {
        width: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;

        img {
          width: 30px;
          height: 30px;
          display: block;
          margin-right: 20px;
        }

        span, p {
          margin: 10px 0;
          color: #fff;
        }
      }
    }
  }

  // 第七部分
  .copyright {
    width: 100%;
    background: var(--new-bgColor2);
    padding: 10px 0;
    font-weight: lighter;
    font-size: 14px;

    .copyright-main {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 40px;

      .copyright-text {
        display: flex;
        color: #fff;
        align-items: center;

        p {
          line-height: 0;
          margin-left: 20px;

          a {
            color: #fff;
          }
        }
      }


      .platform {
        display: flex;
        align-items: center;
        gap: 20px;

        img {
          width: 30px;
          height: 30px;
        }

        :deep(.platform-list) {
          img {
            width: 100%;
          }
        }
      }
    }
  }

  // 移动端适配样式
  // 导航栏
  @media (max-width: 768px) {
    .nav {
      height: 60px; // 减小导航栏高度

      .nav-main {
        width: 95%; // 增加宽度
        padding: 0 10px; // 添加内边距

        .nav-logo {
          width: 30px; // 减小logo尺寸

          img {
            width: 100%;
            height: auto;
          }
        }

        .nav-info {
          position: fixed; // 使用固定定位
          top: 60px; // 位于导航栏下方
          left: 0;
          right: 0;
          background: var(--new-bgColor1);
          flex-direction: column; // 垂直排列
          height: auto; // 自适应高度
          padding: 10px 0;
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
          z-index: 32; // 确保层级
          display: flex; // 始终flex，通过opacity控制显隐
          width: 100%; // 确保宽度
          opacity: 0;
          transform: translateY(-100%); // 初始位置在屏幕上方
          transition: transform 0.3s ease, opacity 0.3s ease; // 添加过渡效果
          pointer-events: none;

          &.mobile-open {
            opacity: 1;
            transform: translateY(0); // 移动到正常位置
            pointer-events: auto;
          }

          .nav-item {
            width: 100%; // 占满宽度
            text-align: left; // 左对齐
            margin: 5px 0; // 添加上下间距
            height: auto; // 自适应高度
            padding: 0 20px; // 添加水平内边距

            a {
              line-height: 40px; // 调整行高
              color: #000; // 滚动后文字颜色
              display: block; // 块级显示
              text-decoration: none; // 去除下划线
              transition: all 0.3s ease; // 添加过渡效果

              &:hover {
                transform: none;
              }
            }

            .learn-more {
              position: static; // 取消绝对定位
              width: 100%;
              background: var(--new-btnColor);
              margin-top: 5px;
              display: none; // 默认隐藏

              span {
                display: block; // 显示文字
                color: #fff;
                padding: 8px 0;
                text-align: center;
                cursor: pointer;
              }
            }
          }

          .active {
            a {
              color: var(--new-btnColor);
              transform: none !important; // 移除缩放效果
              font-weight: bold; // 通过加粗显示激活状态
            }
          }
        }

        .nav-login {
          width: auto; // 自适应宽度
          font-size: 12px; // 减小字体
          margin-right: 25px; // 增加右边距
          z-index: 30; // 确保层级
        }

        .nav-btn {
          display: none; // 隐藏按钮
        }
      }
    }

    // 滚动后的样式
    .scrolled {
      .nav-main {
        .nav-info {
          .nav-item {
            a {
              color: #000; // 滚动后文字颜色
            }
          }

          .nav-login {
            span {
              color: #000; // 滚动后文字颜色
            }
          }
        }
      }
    }

    .nav-main::before {
      content: '☰'; // 汉堡菜单图标
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      cursor: pointer;
      color: #fff;
      z-index: 31;
      display: block; // 确保显示

      .scrolled & {
        color: #000;
      }
    }
  }

  @media (max-width: 480px) {
    .nav {
      height: 60px;

      .nav-main {
        .nav-logo {
          width: 25px; // 进一步减小logo
        }

        .nav-info {
          top: 60px; // 调整位置
          .nav-item {
            padding: 0 15px; // 调整内边距
            a {
              &:hover {
                transform: none;
              }
            }
          }
        }

        .nav-login {
          font-size: 11px; // 进一步减小字体
          margin-right: 40px; // 调整边距
        }
      }
    }
  }

  // 第一部分
  @media (max-width: 768px) {
    .top {
      height: auto !important; // 强制覆盖原有高度
      padding: 80px 0 40px;

      .top-title {
        padding: 0 20px;
        margin: 20px 0;

        .title {
          font-size: 24px; // 大幅减小标题字体
          line-height: 1.3; // 调整行高
          text-align: center;
        }

        .info {
          font-size: 14px; // 减小副标题字体
          margin: 15px 0;
          text-align: center;
        }

        .top-btn {
          flex-direction: column;
          gap: 12px;
          width: 100%;
          max-width: 300px; // 限制最大宽度
          margin: 0 auto; // 居中显示

          span {
            width: 100%; // 保持100%宽度
            padding: 15px 0; // 增加垂直内边距
            margin: 0; // 移除margin
            font-size: 16px; // 稍微增大文字
            min-height: 50px; // 确保最小高度，便于触摸操作

            a {
              display: block;
              width: 100%;
              text-align: center; // 文字居中
            }
          }
        }
      }

      .features {
        width: 95%;
        flex-direction: column;
        padding: 10px 0;

        .feature {
          width: 100%;
          margin: 0 0 15px 0;
          padding: 15px; // 减少padding

          h2 {
            font-size: 18px; // 减小标题字体
            margin: 10px 0;
          }

          .feature-description {
            font-size: 13px; // 减小描述文字
            line-height: 1.5; // 调整行高
            text-indent: 1em;
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .top {
      .top-title {
        .title {
          font-size: 20px; // 进一步减小标题字体
          margin: 10px 0;
        }

        .info {
          font-size: 12px; // 进一步减小副标题字体
        }

        .top-btn {
          max-width: 280px; // 小屏幕下稍微减小最大宽度
          span {
            font-size: 15px; // 小屏幕下字体
            padding: 14px 0; // 调整内边距
            min-height: 48px; // 小屏幕最小高度
          }
        }
      }

      .features {
        .feature {
          padding: 12px;

          h2 {
            font-size: 16px;
          }

          .feature-description {
            font-size: 12px;
          }
        }
      }
    }
  }

  // 第二部分
  @media (max-width: 768px) {
    .team {
      height: auto; // 改为自适应高度
      padding: 60px 0; // 调整内边距
      flex-direction: column; // 垂直排列

      .team-title {
        width: 100%; // 占满宽度
        text-align: center; // 文字居中
        margin-bottom: 30px; // 增加底部间距

        .title {
          font-size: 32px; // 减小标题字体
          margin: 20px 0;

          .title-en {
            font-size: 24px; // 减小英文标题
          }
        }

        span {
          width: 90%; // 增加文字宽度
          font-size: 14px; // 减小字体
          margin: 0 auto; // 居中
        }
      }

      .team-main {
        width: 95%; // 增加主内容宽度
        margin: 0 auto; // 居中

        .team-item {
          flex-direction: column; // 垂直排列图片和文字
          gap: 20px; // 调整间距

          .team-img {
            width: 100% !important; // 图片占满宽度
            height: auto; // 高度自适应
          }

          .team-info {
            width: 100%; // 信息区域占满宽度
            padding: 20px; // 调整内边距

            span {
              font-size: 14px; // 减小字体
              text-align: left; // 文字左对齐
              line-height: 1.6; // 调整行高
            }
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .team {
      padding: 40px 0; // 进一步减小内边距

      .team-title {
        .title {
          font-size: 28px; // 进一步减小标题字体

          .title-en {
            font-size: 20px; // 进一步减小英文标题
          }
        }

        span {
          width: 95%; // 增加宽度
          font-size: 13px; // 进一步减小字体
        }
      }

      .team-main {
        .team-item {
          .team-info {
            padding: 15px; // 减小内边距

            span {
              font-size: 13px; // 进一步减小字体
            }
          }
        }
      }
    }
  }

  // 第三部分
  @media (max-width: 768px) {
    .product {
      height: auto; // 改为自适应高度
      padding: 60px 0; // 调整内边距

      .product-title {
        .title {
          font-size: 32px; // 减小标题字体
          margin: 20px 0;

          .title-en {
            font-size: 24px; // 减小英文标题
          }
        }

        .product-info {
          width: 90%; // 增加信息宽度
          font-size: 14px; // 减小字体
          margin: 10px auto; // 居中
        }
      }

      .product-main {
        width: 95%; // 增加主内容宽度
        margin: 30px auto 0; // 添加上边距30px，移除下边距
        grid-template-columns: repeat(2, 1fr); // 两列布局
        gap: 20px; // 调整间距

        .card {
          margin: 0 auto; // 居中卡片

          .first-content {
            img {
              width: 70%; // 调整图片宽度
            }

            span {
              font-size: 20px; // 减小文字大小
            }
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .product {
      padding: 40px 0; // 进一步减小内边距

      .product-title {
        .title {
          font-size: 28px; // 进一步减小标题字体

          .title-en {
            font-size: 20px; // 进一步减小英文标题
          }
        }

        .product-info {
          width: 95%; // 增加宽度
          font-size: 13px; // 进一步减小字体
        }
      }

      .product-main {
        margin: 25px auto 0; // 添加上边距25px
        grid-template-columns: 1fr; // 单列布局
        gap: 15px; // 调整间距

        .card {
          .first-content {
            img {
              width: 80%; // 调整图片宽度
            }

            span {
              font-size: 18px; // 进一步减小文字大小
            }
          }
        }
      }
    }
  }

  // 第四部分
  @media (max-width: 768px) {
    .partner {
      height: auto; // 改为自适应高度
      padding: 50px 0; // 调整内边距

      .partner-title {
        margin: 40px 0; // 调整标题外边距

        .title {
          font-size: 32px; // 减小标题字体
          margin: 15px 0;

          .title-en {
            font-size: 24px; // 减小英文标题
          }
        }

        .partner-info {
          width: 90%; // 增加信息宽度
          font-size: 14px; // 减小字体
          margin: 10px auto; // 居中
        }
      }

      .app-container {
        width: 95%; // 增加容器宽度
        margin: 0 auto; // 居中

        .logo-wall {
          .scroll-container {
            .logo-group {
              .logo-item {
                height: 60px; // 减小高度
                width: 120px; // 减小宽度
                padding: 8px; // 调整内边距

                img {
                  max-height: 100%;
                  max-width: 100%;
                }
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .partner {
      padding: 40px 0; // 进一步减小内边距

      .partner-title {
        .title {
          font-size: 28px; // 进一步减小标题字体

          .title-en {
            font-size: 20px; // 进一步减小英文标题
          }
        }

        .partner-info {
          width: 95%; // 增加宽度
          font-size: 13px; // 进一步减小字体
          line-height: 1.5; // 调整行高
        }
      }

      .app-container {
        .logo-wall {
          .scroll-container {
            .logo-group {
              .logo-item {
                height: 50px; // 进一步减小高度
                width: 100px; // 进一步减小宽度
                padding: 6px; // 调整内边距
              }
            }
          }
        }
      }
    }
  }

  // 第五部分
  @media (max-width: 768px) {
    .contact {
      height: auto; // 改为自适应高度
      padding: 50px 0; // 调整内边距

      .contact-main {
        .contact-title {
          width: 90%; // 增加标题宽度
          margin: 0 auto 30px; // 调整外边距

          .title {
            font-size: 32px; // 减小标题字体
            margin: 15px 0;

            .title-en {
              font-size: 24px; // 减小英文标题
            }
          }

          span {
            font-size: 14px; // 减小字体
            margin: 10px 0;
          }
        }
      }

      .contact-container {
        flex-direction: column; // 垂直排列表单和地图
        gap: 30px; // 调整间距
        padding: 0 20px; // 添加水平内边距

        .contact-form {
          width: 100%; // 表单占满宽度
          height: auto; // 高度自适应
          padding: 25px; // 调整内边距
          margin: 0 auto; // 居中

          h2 {
            font-size: 22px; // 减小标题字体
          }

          .form-group {
            margin-bottom: 15px; // 调整表单组间距
          }

          .input {
            padding: 12px; // 调整输入框内边距
          }
        }

        .world {
          width: 100%; // 地图占满宽度
          margin: 0 auto; // 居中显示
          min-height: 400px;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .contact {
      padding: 40px 0; // 进一步减小内边距

      .contact-main {
        .contact-title {
          width: 95%; // 进一步增加宽度

          .title {
            font-size: 28px; // 进一步减小标题字体

            .title-en {
              font-size: 20px; // 进一步减小英文标题
            }
          }

          span {
            font-size: 13px; // 进一步减小字体
          }
        }
      }

      .contact-container {
        .contact-form {
          padding: 20px; // 调整内边距
          width: 95%; // 调整宽度

          h2 {
            font-size: 20px; // 进一步减小标题字体
          }

          .form-group {
            label {
              font-size: 14px; // 减小标签字体
            }

            input {
              padding: 10px; // 调整输入框内边距
            }
          }

          .button-style {
            padding: 12px 0; // 调整按钮内边距
          }
        }

        .world {
          width: 95%; // 调整宽度
          min-height: 400px;
        }
      }
    }
  }

  //  第六部分
  @media (max-width: 768px) {
    .footer {
      padding: 20px 0; // 减小内边距

      .footer-contact-main {
        width: 95%; // 增加宽度
        flex-direction: column; // 垂直排列
        gap: 20px; // 调整间距

        .footer-contact {
          width: 100%; // 占满宽度
          justify-content: center; // 居中对齐

          img {
            width: 24px; // 减小图标尺寸
            height: 24px;
          }

          span, p {
            font-size: 13px; // 减小字体
          }
        }
      }
    }

    // 第七部分 - 版权
    .copyright {
      padding: 15px 0; // 减小内边距

      .copyright-main {
        width: 95%; // 增加宽度
        flex-direction: column; // 垂直排列
        gap: 15px; // 调整间距

        .copyright-text {
          flex-direction: column; // 垂直排列
          gap: 10px; // 调整间距
          text-align: center; // 文字居中

          span {
            font-size: 13px; // 减小字体
          }

          p {
            margin: 0; // 重置边距
            line-height: 1;

            a {
              font-size: 12px; // 链接字体
            }
          }
        }

        .platform {
          gap: 15px; // 调整平台图标间距

          img {
            width: 24px; // 减小图标尺寸
            height: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .footer {
      .footer-contact-main {
        .footer-contact {
          gap: 10px; // 调整间距

          img {
            width: 20px; // 进一步减小图标
            height: 20px;
          }

          span, p {
            font-size: 12px; // 进一步减小字体
          }
        }
      }
    }

    .copyright {
      .copyright-main {
        .copyright-text {
          span {
            font-size: 12px; // 进一步减小字体
          }

          p {
            a {
              font-size: 11px; // 链接字体
            }
          }
        }

        .platform {
          gap: 10px; // 调整间距

          img {
            width: 20px; // 进一步减小图标
            height: 20px;
          }
        }
      }
    }
  }


}
// 手机端回到顶部按钮减小距离
@media (max-width: 767px) {
  :deep(.el-backtop) {
    bottom: 20px !important;
    right: 20px !important;
  }
}
</style>
